import styled from 'styled-components';
import rmq from 'styled-rmq';

export default styled.img`
	position: absolute;
	width: 20rem;
	right: -5rem;
	top: -7.5rem;

	${rmq('ls')} {
		right: 1rem;
		top: -10.5rem;
	}
	${rmq('700')} {
		width: 15rem;
		right: 5rem;
		top: -8rem;
	}
	${rmq('485')} {
		right: 2rem;
	}
	${rmq('ml')} {
		width: 13rem;
		top: -6.5rem;
	}
	${rmq('mm')} {
		width: 10rem;
		top: -5rem;
	}
	${rmq('ms')} {
	}
`;
